import { ThemeColors } from '@octopus-do/octopus-storybook'
import type React from 'react'

import { clsJoin } from '@/utils'
import { SkeletonNodeLine } from '../../icons'
import css from './PagePreview.module.scss'

type Props = {
  sheetDarkTheme: boolean
  style: React.CSSProperties
}

export const PagePreview: React.FC<Props> = ({ sheetDarkTheme, style }) => (
  <div
    className={clsJoin(css.previewNode, sheetDarkTheme && ThemeColors.light)}
  >
    <div className={css.previewNodeHeader} style={{ color: style.color }}>
      <SkeletonNodeLine />
    </div>

    <div className={css.previewNodeSquare} style={style} />
    <div
      className={clsJoin(css.previewNodeSquare, css['h-30'])}
      style={style}
    />
    <div className={css.previewNodeSquare} style={style} />
    <div className={css.previewNodeSquare} style={style} />
  </div>
)
